import React from 'react';

import {
  PeoStaffListDocument,
  useCheckDeletionPeoStaffQuery,
  useDeletePeoStaffMutation,
} from 'src/api';
import { useNotification } from 'src/hooks/app';
import { DeleteConfirmationModal } from 'src/modals/common';
import { ModalV2Props } from 'src/types/modalV2';

type DeletePeoStaffConfirmationModalProps = {
  peoStaffId: string;
};

export const DeletePeoStaffConfirmationModal: React.FC<
  ModalV2Props<DeletePeoStaffConfirmationModalProps>
> = ({ id, peoStaffId }) => {
  const { createApolloContext } = useNotification();

  const { data, loading } = useCheckDeletionPeoStaffQuery({
    variables: { peoStaffId },
    fetchPolicy: 'network-only',
  });

  const [deletePeoStaff, { loading: deleteLoading }] = useDeletePeoStaffMutation({
    refetchQueries: [PeoStaffListDocument],
    context: createApolloContext({ successMessage: 'Successfully deleted' }),
  });

  const handleConfirm = React.useCallback(
    () => deletePeoStaff({ variables: { peoStaffId } }),
    [deletePeoStaff, peoStaffId],
  );

  return (
    <DeleteConfirmationModal
      id={id}
      entityName="PEO staff"
      description="You want to delete this staff member?"
      check={data?.checkDeletionPeoStaff}
      loading={loading}
      deleteLoading={deleteLoading}
      onConfirm={handleConfirm}
    />
  );
};
